export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^((0[1-9])|([1-7][0-9])|(8[01]))[0-9]{3}$/));
    }
}
